/*! Copyright (c) Safe As Milk. All rights reserved. */
/* DW: rebuilt safely. Stored queries are rendered as text (the original inserted them as HTML,
   which let a crafted /search?q=<img onerror=…> link run script). Storage access is guarded,
   only same-origin search URLs are used, and a Clear button empties the list. */
class RecentSearches extends HTMLElement {
    constructor() {
        super();
        this.update();
        this.addEventListener("click", (e) => {
            if (!e.target.closest("[data-dw-clear-recent]")) return;
            try { localStorage.removeItem("recentSearches"); } catch (err) { /* storage unavailable */ }
            const ul = this.querySelector("ul");
            if (ul) ul.textContent = "";
            this.setAttribute("hidden", "");
        });
    }
    static read() {
        try {
            const items = JSON.parse(localStorage.getItem("recentSearches") || "[]");
            return Array.isArray(items) ? items : [];
        } catch (err) {
            return [];
        }
    }
    static safeUrl(uri) {
        try {
            const u = new URL(uri, window.location.origin);
            return u.origin === window.location.origin ? u.pathname + u.search : null;
        } catch (err) {
            return null;
        }
    }
    update() {
        const ul = this.querySelector("ul");
        if (!ul) return;
        const items = RecentSearches.read().filter((item) => item && typeof item.query === "string" && item.query.trim()).reverse();
        ul.textContent = "";
        items.forEach((item) => {
            const href = RecentSearches.safeUrl(item.uri);
            if (!href) return;
            const li = document.createElement("li");
            const a = document.createElement("a");
            a.className = "dw-sx__chip";
            a.href = href;
            a.textContent = item.query.trim().slice(0, 80);
            li.append(a);
            ul.append(li);
        });
        if (ul.children.length) {
            if (this.parentElement) this.parentElement.classList.add("has-recent-searches");
            this.removeAttribute("hidden");
        } else {
            this.setAttribute("hidden", "");
        }
    }
}

customElements.define("recent-searches", RecentSearches);
